import script from "./ErrorText.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorText.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorText.vue?vue&type=style&index=0&id=1bed1ffc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bed1ffc"]])

export default __exports__